// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-89e4c1c6] .el-button i {\n  color: #000 !important;\n}\n", ""]);
